/* eslint-disable react/prop-types */
import React from "react";

const ProgressBarSection = ({ status, numberOfTasks, totalNumberOfTasks }) => {
  const percentageOfTasks = Math.round((numberOfTasks / totalNumberOfTasks) * 100);

  if (numberOfTasks === 0) return <></>;
  return (
    <div
      className={`to-do-list-progress-bar-section to-do-list-progress-bar-section--${status}`}
      style={{ width: `${percentageOfTasks}%` }}
    />
  );
};

const ToDoListProgressBar = (to_do_list_progress_bar_counts) => {
  // Extracting label information into a single variable
  const labelsInfo = [
    { count: to_do_list_progress_bar_counts.completed, label: "Completed", status: "completed" },
    { count: to_do_list_progress_bar_counts.skipped, label: "Skipped", status: "skipped" },
    { count: to_do_list_progress_bar_counts.incomplete, label: "Incomplete", status: "incomplete" },
    { count: to_do_list_progress_bar_counts.ignored, label: "Ignored", status: "ignored" },
    { count: to_do_list_progress_bar_counts.inProgress, label: "In progress", status: "inprogress" }
  ];
  // Filtering out and displaying labels with count>0
  const filteredLabelsInfo = labelsInfo.filter((info) => info.count > 0);
  const total = to_do_list_progress_bar_counts.total;

  return (
    <div className="ccw-todo-progress">
      <div
        className="to-do-list-progress-bar-container"
        role="img"
        aria-label={`${filteredLabelsInfo
          .map((info) => `${info.label}: ${info.count}`)
          .join(", ")}. Total: ${total}`}
      >
        {filteredLabelsInfo.map((info) => (
          <ProgressBarSection
            key={info.status}
            numberOfTasks={info.count}
            status={info.status}
            totalNumberOfTasks={total}
          />
        ))}
      </div>
      <div className="to-do-list-progress-bar-label-container">
        {filteredLabelsInfo.map((info) => (
          <div
            key={info.status}
            className={`to-do-list-progress-bar-label to-do-list-progress-bar-label--${info.status}`}
            data-todo_list_test_id_count={`todo_list_progress_bar_section_label_count_${info.status}_${info.count}`}
            data-explorator_test_id={`todo_list_progress_bar_section_label_${info.status}`}
          >
            <span aria-hidden="true" className="to-do-list-progress-bar-label__swatch" />
            <span>
              {info.label}: {info.count}
            </span>
          </div>
        ))}
        {filteredLabelsInfo.length > 0 && (
          <div className="to-do-list-progress-bar-total-count">Total: {total}</div>
        )}
      </div>
    </div>
  );
};

export default ToDoListProgressBar;
